import { render, staticRenderFns } from "./UserIconItem.vue?vue&type=template&id=73dee3b5"
import script from "./UserIconItem.vue?vue&type=script&lang=js"
export * from "./UserIconItem.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports